import React from 'react';
import { CHECKOUT_STEPS } from './checkoutConstants';

const StepIndicator = ({ currentStep, onStepClick }) => (
  <div className="mb-10 flex items-center">
    {CHECKOUT_STEPS.map((s, idx) => (
      <React.Fragment key={s.id}>
        <div className="flex flex-col items-center">
          <button
            type="button"
            onClick={() => currentStep > s.id && onStepClick(s.id)}
            className={[
              'flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold transition-all duration-300',
              currentStep > s.id
                ? 'cursor-pointer bg-primary-600 text-white shadow-lg shadow-primary-600/30'
                : currentStep === s.id
                ? 'bg-primary-600 text-white shadow-lg shadow-primary-600/30 ring-4 ring-primary-600/20'
                : 'cursor-default bg-gray-100 text-gray-400',
            ].join(' ')}
          >
            {currentStep > s.id ? (
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              s.id
            )}
          </button>
          
            <span
              className={`mt-2 text-[11px] font-bold uppercase tracking-wider ${
                currentStep >= s.id ? 'text-primary-600' : 'text-gray-400'
              }`}
          >
            {s.label}
          </span>
        </div>

        {idx < CHECKOUT_STEPS.length - 1 && (
          <div
            className={`mx-2 mb-6 h-0.5 flex-1 rounded-full transition-all duration-500 ${
              currentStep > s.id ? 'bg-primary-600' : 'bg-gray-200'
            }`}
          />
        )}
      </React.Fragment>
    ))}
  </div>
);

export default StepIndicator;
